export default "__VITE_ASSET__cZ3DXUoq__"